// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OsZHF2V2TbiW9_gXQs_H {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: var(--qa-questionTextColor);
    border-radius: 10px;
    /* box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px; */
    border: 0.5px solid var(--qa-questionBorderColor);
    background-color: var(--qa-questionBackgroundColor);
}

.OsZHF2V2TbiW9_gXQs_H:hover {
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

.v3WFuRE2eujNDSiVPioE {
    cursor: pointer;
    font-size: var(--qa-questionFontSize);
    width: 100%;
    padding: 10px 5px 10px 0px;
    border-radius: 5px;
    text-align: left;
    font-weight: 500;
}

.qjlqa1zfi4duKeoCV8FX {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px 5px 10px;
    font-size: 14px;
    color: var(--qa-questionIconColor);
}`, "",{"version":3,"sources":["webpack://./app/components/Question/Question.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kCAAkC;IAClC,mBAAmB;IACnB,yFAAyF;IACzF,iDAAiD;IACjD,mDAAmD;AACvD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;IACf,kCAAkC;AACtC","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    color: var(--qa-questionTextColor);\n    border-radius: 10px;\n    /* box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px; */\n    border: 0.5px solid var(--qa-questionBorderColor);\n    background-color: var(--qa-questionBackgroundColor);\n}\n\n.container:hover {\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n\n.question {\n    cursor: pointer;\n    font-size: var(--qa-questionFontSize);\n    width: 100%;\n    padding: 10px 5px 10px 0px;\n    border-radius: 5px;\n    text-align: left;\n    font-weight: 500;\n}\n\n.icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px 5px 10px;\n    font-size: 14px;\n    color: var(--qa-questionIconColor);\n}"],"sourceRoot":""}]);
// Exports
export var container = `OsZHF2V2TbiW9_gXQs_H`;
export var question = `v3WFuRE2eujNDSiVPioE`;
export var icon = `qjlqa1zfi4duKeoCV8FX`;
export default ___CSS_LOADER_EXPORT___;
